var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98464 13.8508C9.11297 13.9791 9.28714 14.0525 9.47047 14.0525C9.6538 14.0525 9.82797 13.9791 9.9563 13.8508L15.1538 8.6533C15.4196 8.38747 15.4196 7.94747 15.1538 7.68163C14.888 7.4158 14.448 7.4158 14.1821 7.68163L9.47047 12.3933L7.36214 10.285C7.0963 10.0191 6.6563 10.0191 6.39047 10.285C6.12464 10.5508 6.12464 10.9908 6.39047 11.2566L8.98464 13.8508Z",
    fill: "#2E7D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.917969 10.7708C0.917969 16.2066 5.3363 20.625 10.7721 20.625C16.208 20.625 20.6263 16.2066 20.6263 10.7708C20.6263 5.33496 16.208 0.916626 10.7721 0.916626C5.3363 0.916626 0.917969 5.33496 0.917969 10.7708ZM2.29297 10.7708C2.29297 6.09579 6.09714 2.29163 10.7721 2.29163C15.4471 2.29163 19.2513 6.09579 19.2513 10.7708C19.2513 15.4458 15.4471 19.25 10.7721 19.25C6.09714 19.25 2.29297 15.4458 2.29297 10.7708Z",
    fill: "#2E7D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.8770a325e02c63f8da58951df01873ac.svg";
export { ForwardRef as ReactComponent };